import { SolanaNFTCollection } from '@repo/types-client';

import { solanaContractAddresses } from './solana-contract-addresses';

export interface SolanaNFTCollections {
  readonly doopies: SolanaNFTCollection;
}

export const solanaNFTCollections: SolanaNFTCollections = {
  doopies: {
    contractName: 'Doopies',
    getAddress: () => solanaContractAddresses.doopies,
  },
} as const;
